/* eslint-disable */
// @ts-nocheck
import React from "react";
import { Box, Button, Checkbox, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function FileTypesDrawer({
  open,
  setOpen,
  fileTypes,
  formatKey,
  selectedAppSetting,
  setSelectedAppSetting,
  handleSaveFileTypes,
}: any) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: {
          width: 400,
          maxWidth: "90vw",
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          boxShadow: 4,
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight={600}>
          Manage File Types
        </Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, fontSize: 13, fontWeight: 500 }}
      >
        File type list
        <br />
        Manage or add the list that can be uploaded
      </Typography>

      <Box>
        {fileTypes.map((type, idx) => (
          <Box
            key={type}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            py={1.2}
            sx={{
              borderBottom: idx < fileTypes.length - 1 ? "1px solid #e0e0e0" : "none",
            }}
          >
            <Typography variant="body2" fontWeight={500}>
              {formatKey(type)}
            </Typography>
            <Checkbox
              checked={!!selectedAppSetting[type]}
              onChange={() => setSelectedAppSetting((prev) => ({ ...prev, [type]: !prev[type] }))}
              sx={{ color: "grey.400", "&.Mui-checked": { color: "success.main" } }}
            />
          </Box>
        ))}
      </Box>

      <Button
        variant="text"
        sx={{ mt: 2, fontWeight: 500, textTransform: "none", color: "#1976d2", fontSize: 14 }}
      >
        + Add Other
      </Button>
      <Button
        variant="contained"
        fullWidth
        sx={{ mt: "auto", textTransform: "capitalize" }}
        onClick={handleSaveFileTypes}
      >
        Save File Types
      </Button>
    </Drawer>
  );
}
